import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { Wrapper, Participants, Savings } from './elements';
import DayStats from './DayStats';
import { formatNumber, getIndicatorConfig, getIndicator } from 'utils/common';
import { useText } from 'common/hooks';

type Props = {
  readonly className?: string;
};

const deps = {
  indicator: state.challenge.campaign.indicator,
  totalParticipantCount: state.challenge.campaign.structure.participantCount,
  challengeTotalStats: state.challenge.stats.total.challenge,
  indicatorModalClicked: sequences`challenge.info.indicatorModalClicked`,
};

export function BasicStats({
  className,
  totalParticipantCount = 0,
  indicator = 'default',
  challengeTotalStats,
  indicatorModalClicked,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Wrapper className={className}>
      <DayStats />
      <Participants
        number={totalParticipantCount}
        textcontent={
          totalParticipantCount === 0
            ? '-'
            : t('challenge.ChaMeta01.participants')
        }
        locale={t.fullLocale}
      />
      <Savings
        animation
        decimals={0}
        caption={t(`challenge.ChaMeta01.total_${indicator}`)}
        icon={getIndicatorConfig(indicator).icon}
        iconColor={getIndicatorConfig(indicator).color}
        onClick={() =>
          indicator !== 'default' && indicatorModalClicked({ indicator })
        }
        tooltipText={t(`challenge.ChaMeta01.total_${indicator}_tooltip`)}
        locale={t.fullLocale}
      >
        {formatNumber(getIndicator(challengeTotalStats, indicator), {
          locale: t.fullLocale,
          precision: getIndicatorConfig(indicator).precision,
        })}
      </Savings>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, BasicStats);
